module.exports = __webpack_public_path__ + "fonts/Jost-800-Hevy.a81114e.otf";